import React from 'react'
import { IDropdownPosition } from './TranslationLanguagesTts'
import Arrow from '@Images/languages_dropdown_arrow.svg'
import Remove from '@Images/project_setup_form_remove_language.svg'

interface TranslationLanguageTtsProps {
  readonly index: number
  readonly currentNewTranslationLanguage: string
  readonly newTranslationLanguages: string[]
  readonly indexForReplacingTranslationLanguages: number
  readonly dropdownOffsetY: number
  setIndexForReplacingTranslationLanguages(newIndexForReplacingTranslationLanguages: number): void
  setNewTranslationLanguages(newTranslationLanguages: string[]): void
  renderSearchInput(currentTranslationLanguage?: string): React.JSX.Element
  renderTranslationLanguages(style: IDropdownPosition, languageIndexToReplace?: number): React.JSX.Element
}

const TranslationLanguageTts: React.FC<TranslationLanguageTtsProps> = props => {
  const {
    index,
    newTranslationLanguages,
    currentNewTranslationLanguage,
    dropdownOffsetY,
    indexForReplacingTranslationLanguages,
  } = props

  const shouldShowDropdown = indexForReplacingTranslationLanguages === index

  const openTranslationLanguages = () => {
    props.setIndexForReplacingTranslationLanguages(index)
  }

  const handleRemoveTranslationLanguage = () => {
    props.setNewTranslationLanguages([...newTranslationLanguages.slice(0, index), ...newTranslationLanguages.slice(index + 1)])
  }

  const renderCurrentItem = () => {
    return (
      <div
        className="SearchDropdown__current-item"
        onClick={openTranslationLanguages}
      >
        <div className="SearchDropdown__current-item-name">
          {currentNewTranslationLanguage}
        </div>
        <Arrow />
      </div>
    )
  }

  const renderButtons = () => {
    return (
      <div className="SetupProjectPopupTts__buttons">
        {renderRemoveButton()}
      </div>
    )
  }

  const renderRemoveButton = () => {
    return (
      <div
        className="SetupProjectPopupTts__button"
        onClick={handleRemoveTranslationLanguage}
      >
        <Remove />
      </div>
    )
  }

  const newTranslationLanguageDropdownParentElement = document.getElementById(`translation_languages_new_translations-item-${index}`)
  let newTranslationLanguageDropdownX = 0
  let newTranslationLanguageDropdownY = 0

  if (newTranslationLanguageDropdownParentElement) {
    const newTranslationLanguageDropdownParentElementBounds = newTranslationLanguageDropdownParentElement.getBoundingClientRect()

    newTranslationLanguageDropdownX = newTranslationLanguageDropdownParentElementBounds.left
    newTranslationLanguageDropdownY = newTranslationLanguageDropdownParentElementBounds.top + dropdownOffsetY
  }

  const newTranslationLanguageDropdownPositioningStyle = {
    top: `${newTranslationLanguageDropdownY}px`,
    left: `${newTranslationLanguageDropdownX}px`,
  }

  return (
    <li
      className="TranslationLanguagesTts__new-translations-item"
      id={`translation_languages_new_translations-item-${index}`}
    >
      <div className="TranslationLanguagesTts__new-translations-item-main TranslationLanguagesTts__new-translations-item-main-element">
        {shouldShowDropdown ? (
          <React.Fragment>
            {props.renderSearchInput(currentNewTranslationLanguage)}
            {props.renderTranslationLanguages(newTranslationLanguageDropdownPositioningStyle, index)}
          </React.Fragment>
        ) : (
          <React.Fragment>
            {renderCurrentItem()}
            {renderButtons()}
          </React.Fragment>
        )}
      </div>
    </li>
  )
}

export default TranslationLanguageTts
